import React from 'react';
import { SHORT_CAROUSEL_ASPECT_RATIO } from '../constants';
import CarouselCard from './CarouselCard';
import { commonDefaultProps, commonPropTypes } from './constants';

const ShortCarouselCard = props => (
  <CarouselCard
    aspectRatio={SHORT_CAROUSEL_ASPECT_RATIO}
    {...props}
  />
);

ShortCarouselCard.propTypes = commonPropTypes;
ShortCarouselCard.defaultProps = commonDefaultProps;

export default ShortCarouselCard;
